import VerifyCodePage from "./VerifyCodePage";

export default VerifyCodePage;